import L from "leaflet";

const PIN_SVG = (color = "#2e7be7") => `
<svg width="25" height="41" viewBox="0 0 25 41" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.5 0C5.59644 0 0 5.59236 0 12.4918C0 22.0111 12.5 41 12.5 41C12.5 41 25 22.0111 25 12.4918C25 5.59236 19.4036 0 12.5 0Z" fill="${color}" stroke="white" stroke-width="2"/>
  <circle cx="12.5" cy="12.5" r="4.5" fill="white" opacity="0.85"/>
</svg>
`;

export const buildPinIcon = (color = "#2e7be7") =>
  L.divIcon({
    className: "checkpoint-pin-icon",
    html: PIN_SVG(color),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  });

